var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38086 26.3047H25.7188C27.8672 26.3047 29.1348 25.0479 29.1348 22.6953V10.8145C29.1348 8.46191 27.8672 7.20508 25.4932 7.20508H8.14453C5.99609 7.20508 4.73926 8.46191 4.73926 10.8145V22.6953C4.73926 25.0586 6.00684 26.3047 8.38086 26.3047ZM15.7715 17.0234L8.14453 9.48242C8.23047 9.47168 8.32715 9.47168 8.42383 9.47168H25.4395C25.5469 9.47168 25.6543 9.47168 25.751 9.49316L18.124 17.0234C17.6836 17.4531 17.3291 17.6357 16.9424 17.6357C16.5664 17.6357 16.2119 17.4424 15.7715 17.0234ZM6.96289 11.1367L12.6025 16.6904L6.96289 22.2764V11.1367ZM21.293 16.6797L26.9004 11.1689V22.2549L21.293 16.6797ZM8.42383 24.0488C8.29492 24.0488 8.17676 24.0381 8.05859 24.0166L14.0312 18.0977L14.5469 18.6025C15.3418 19.3867 16.1152 19.7197 16.9424 19.7197C17.7803 19.7197 18.5537 19.3867 19.3379 18.6025L19.8535 18.0977L25.8262 24.0166C25.708 24.0381 25.5791 24.0488 25.4395 24.0488H8.42383Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherIcon);
export default __webpack_public_path__ + "static/media/other-icon.1fef861b03975755ec7c2473b817ad55.svg";
export { ForwardRef as ReactComponent };